function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useTheme } from "../../../lib/hooks";
import { cn } from "../../../lib/utils";
import React from 'react';
import { molySpinAnimate, molySpinTextColor } from "../../style/spin";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Spin = function Spin(props) {
  var _props$theme;
  var _useTheme = useTheme(),
    _useTheme2 = _slicedToArray(_useTheme, 1),
    htmlTheme = _useTheme2[0];
  var theme = (_props$theme = props.theme) !== null && _props$theme !== void 0 ? _props$theme : htmlTheme;
  var color = theme === 'light' ? '#000' : '#fff';
  var size = typeof props.size === 'number' ? props.size : 64;
  if (props.size === 'small') {
    size = 48;
  } else if (props.size === 'large') {
    size = 96;
  }

  // 默认为 true
  var spinning = props.spinning === false ? false : true;
  var isNested = props.children !== undefined;
  var baseStyle = {
    display: 'inline-block',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationFillMode: 'both'
  };
  var logo = function logo(style) {
    return /*#__PURE__*/_jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      viewBox: "0 0 54 15",
      fill: "none",
      style: _objectSpread({
        display: 'inline',
        padding: 4,
        transitionProperty: 'opacity',
        transitionDuration: '0.4s',
        opacity: spinning ? '1' : '0'
      }, style || {}),
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.03751 14.9988H0V0.455078H5.79357C8.60948 0.455078 10.2508 2.04847 10.2508 4.54014C10.2508 6.15492 9.19812 7.1949 8.46895 7.54245C9.3413 7.95149 10.4549 8.87117 10.4549 10.8121C10.4549 13.5284 8.60948 14.9988 6.03751 14.9988ZM5.57084 2.98686H2.81591V6.33939H5.57084C6.76668 6.33939 7.43486 5.66567 7.43486 4.66312C7.43486 3.66324 6.76668 2.98686 5.57084 2.98686ZM5.7538 8.89256H2.81591V12.467H5.7538C7.02918 12.467 7.63903 11.6489 7.63903 10.6704C7.63903 9.68925 7.02918 8.89256 5.7538 8.89256Z",
        fill: color,
        style: _objectSpread(_objectSpread({}, baseStyle), {}, {
          animationName: 'moly-spin',
          animationDelay: '50ms'
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.04326 9.03425V14.9988H5.24856V9.03425L0.91333 0.455078H3.97318L6.66713 6.318L9.3213 0.455078H12.3785L8.04326 9.03425Z",
        fill: color,
        transform: "translate(11, 0)",
        style: _objectSpread(_objectSpread({}, baseStyle), {}, {
          animationName: 'moly-spin-1',
          animationDelay: '100ms'
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.03751 14.9988H0V0.455078H5.79357C8.60948 0.455078 10.2508 2.04847 10.2508 4.54014C10.2508 6.15492 9.19812 7.1949 8.46895 7.54245C9.3413 7.95149 10.4549 8.87117 10.4549 10.8121C10.4549 13.5284 8.60948 14.9988 6.03751 14.9988ZM5.57084 2.98686H2.81591V6.33939H5.57084C6.76668 6.33939 7.43486 5.66567 7.43486 4.66312C7.43486 3.66324 6.76668 2.98686 5.57084 2.98686ZM5.7538 8.89256H2.81591V12.467H5.7538C7.02918 12.467 7.63903 11.6489 7.63903 10.6704C7.63903 9.68925 7.02918 8.89256 5.7538 8.89256Z",
        fill: color,
        transform: "translate(25 0)",
        style: _objectSpread(_objectSpread({}, baseStyle), {}, {
          animationName: 'moly-spin-2',
          animationDelay: '150ms'
        })
      }), /*#__PURE__*/_jsx("rect", {
        width: "3",
        height: "15",
        transform: "translate(38 -5)",
        fill: "#F7A600",
        style: _objectSpread(_objectSpread({}, baseStyle), {}, {
          animationName: 'moly-spin-3',
          animationDelay: '200ms'
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.74998 2.98686V14.9988H3.93407V2.98686H0.16626V0.455078H10.5178V2.98686H6.74998Z",
        transform: "translate(43 0)",
        fill: color,
        style: _objectSpread(_objectSpread({}, baseStyle), {}, {
          animationName: 'moly-spin-4',
          animationDelay: '250ms'
        })
      })]
    });
  };
  var indicator = props.indicator || logo();
  var containerPrifexCls = 'absolute w-[100%] h-[100%] left-0 top-0 overflow-hidden';
  var backdropCls = theme === 'light' ? 'bg-white opacity-60' : 'bg-black opacity-50';
  // const tipColor = theme === 'light' ? 'text-black' : 'text-white';
  var tipColor = molySpinTextColor;
  var tipFontSize = 'text-[14px]';
  if (props.indicator === undefined) {
    tipFontSize += ' translate-y-[-14px]';
  }
  if (props.size === 'small') {
    tipFontSize = 'text-[12px]';
    if (props.indicator === undefined) {
      tipFontSize += ' translate-y-[-12px]';
    }
  }
  if (props.size === 'large') {
    tipFontSize = 'text-[18px]';
    if (props.indicator === undefined) {
      tipFontSize += ' translate-y-[-18px]';
    }
  }
  if (!isNested) {
    return indicator;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: cn(molySpinAnimate, props.wrapperClassName || '', 'relative overflow-hidden'),
    children: [props.children, spinning ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: cn(containerPrifexCls, backdropCls)
      }), /*#__PURE__*/_jsxs("div", {
        className: cn(containerPrifexCls, 'grid', 'justify-center content-center'),
        children: [indicator, props.tip ? /*#__PURE__*/_jsx("div", {
          className: cn('text-center', tipColor, tipFontSize),
          children: props.tip
        }) : null]
      })]
    }) : null]
  });
};